/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ZendeskKnowledge,
    ZendeskKnowledgeFromJSON,
} from '../models';

/**
 *
 */
export class ZendeskKnowledgeApi extends runtime.BaseAPI {

    /**
     * Get Zendesk Knowledge
     */
    async getZendeskKnowledgeApiZendeskKnowledgeGetRaw(): Promise<runtime.ApiResponse<ZendeskKnowledge>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("HTTPBearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/zendesk-knowledge`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ZendeskKnowledgeFromJSON(jsonValue));
    }

    /**
     * Get Zendesk Knowledge
     */
    async getZendeskKnowledgeApiZendeskKnowledgeGet(): Promise<ZendeskKnowledge> {
        const response = await this.getZendeskKnowledgeApiZendeskKnowledgeGetRaw();
        return await response.value();
    }

}
